import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./Footer.module.css";
import useHelpers from "@hooks/useHelpers";
import { useLang } from "@/common/Contexts/LanguageContext";
import { CARS_PRICES_BASE_PATH } from "@/pages/car-prices/helpers/carsPricesHelpers";
import SyarahLogo from "@/components/SyarahLogo/SyarahLogo";
function Footer(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      borderTop: props.hideFooterWithoutAuthMsg ? "none" : undefined
    },
    className: [stl.footer, props.hideFooterWithoutAuthMsg ? stl.hideFooterWithoutAuthMsg : undefined].join(" ")
  }, !props.hideFooterWithoutAuthMsg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.footerLogo
  }, /*#__PURE__*/React.createElement(SyarahLogo, {
    width: 83,
    height: 38,
    alt: "syarah logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.footerContentWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/footer/footer_back.png",
    width: 876,
    className: stl.footerBackImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.topRow
  }, /*#__PURE__*/React.createElement("nav", {
    className: stl.navLinks
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/")
  }, t("home", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/about-us")
  }, t("about_us", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/contact-us")
  }, t("call_2", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: "https://syarah.com/carsguide/".concat(lang === "en" ? "en/" : "")
  }, t("carsguide", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/network"),
    rel: "noopener noreferrer"
  }, t("affiliate_program", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", {
    className: stl.navBreak
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/trend"),
    rel: "noopener noreferrer"
  }, t("syarah_trend", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl(CARS_PRICES_BASE_PATH)
  }, t("car_prices", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: "".concat(createUrl("/fleet"), "?referral_location=footer")
  }, t("b2b_sales", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/landing")
  }, t("support_pages", {
    ns: "web_footer"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.socialAndLocation
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/contact-us") + "?scrollTo=contact-map",
    className: stl.companyAddressBtn
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mdi_location.svg",
    alt: "",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("span", null, t("location", {
    ns: "web_aside_menu"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.socialIcons
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.snapchat.com/add/syarah_ksa",
    className: stl.socialIcon,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/snapchatIcon.svg",
    alt: "snapchat",
    width: 36,
    height: 36
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.youtube.com/channel/UCAceZ20JD3qef5OQSVc95Bw",
    className: stl.socialIcon,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/youtubeIcon.svg",
    alt: "youtube",
    width: 36,
    height: 36
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/Syarah_ksa",
    className: stl.socialIcon,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/twitterIcon.svg",
    alt: "twitter",
    width: 36,
    height: 36
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/company/syarah-ltd",
    className: stl.socialIcon,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/linkedinIcon.svg",
    alt: "linkedin",
    width: 36,
    height: 36
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/syarah.KSA",
    className: stl.socialIcon,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Facebook Icon.svg",
    alt: "facebook",
    width: 36,
    height: 36
  }))))), /*#__PURE__*/React.createElement("hr", {
    className: stl.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.mainContent
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.registrySection
  }, /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, t("saudi_company_commercial_registry_1010538980", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.legalLinks
  }, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/terms-landing"),
    rel: "noopener noreferrer"
  }, t("terms_conditions", {
    ns: "web_footer"
  })), " | ", /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/privacy-policy"),
    rel: "noopener noreferrer"
  }, t("privacy_policy", {
    ns: "web_footer"
  })), " | ", /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/return-policy"),
    rel: "noopener noreferrer"
  }, tShort("return_policy"))))), /*#__PURE__*/React.createElement("div", {
    className: stl.mainContent
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.mapSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.mapCard
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.0179846607275!2d46.8348856!3d24.7605725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2fab6abe210645%3A0xb6b6a73b3bdd70b6!2sSyarah%20Ltd.!5e0!3m2!1sen!2sjo!4v1700392307735!5m2!1sen!2sjo",
    width: "100%",
    height: "140",
    loading: "lazy",
    referrerPolicy: "no-referrer-when-downgrade"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.addressRow
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/location_on-24px@1Blue.svg",
    alt: "",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("alnahda_khurais_district", {
    ns: "web_common"
  }), " ", t("riyadh_13222", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", null, t("saudi_arabia", {
    ns: "web_common"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: stl.paymentSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.payment
  }, /*#__PURE__*/React.createElement("strong", {
    className: "greenGrd"
  }, /*#__PURE__*/React.createElement("span", null, t("safe_payment_methods", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: stl.paymentRow
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Visadark",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-mc",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-apple_pay",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-BankTransfer",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  })))), /*#__PURE__*/React.createElement("ul", {
    className: stl.paymentRow
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_tabby_logo.png",
    className: stl.bnplIcon,
    alt: "tabby"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_tamara_logo.png",
    className: stl.bnplIcon,
    alt: "tamara"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_amwal_logo.png",
    className: stl.bnplIcon,
    alt: "amwal"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Mada",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path7"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path8"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path9"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Sadad",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: stl.appBanner
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.appBannerInner].join(" ")
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.appBannerText
  }, t("download_app_smarter_experience", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.appStoreButtons
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://apps.apple.com/us/app/id1066260672",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/store-ios.svg",
    alt: "App Store",
    height: 40
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=app.com.syarah",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/store-android.svg",
    alt: "Google Play",
    height: 40
  })))), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/footer/Right - Footer.png",
    className: stl.appBannerImgRight,
    alt: ""
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/footer/Left - Footer.png",
    className: stl.appBannerImgLeft,
    alt: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.copyrightBar
  }, /*#__PURE__*/React.createElement("p", null, t("rights_reserved_syarah_ltd_year", {
    ns: "web_footer",
    year: new Date().getFullYear()
  }))))), props.authenticationMsg && /*#__PURE__*/React.createElement("div", {
    className: stl.authenticationMsg
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "container"].join(" ")
  }, /*#__PURE__*/React.createElement("p", null, t("syarah_registered_company_ministry_trade", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.footerWithVat
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.vatLink,
    href: CDN_LINK + "/assets/bundles/GAZT_VAT_Certificate.pdf",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: "30px",
    height: "38px",
    src: CDN_LINK + "/assets/images/Vat.svg",
    alt: "vat icon"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saudi_elm.svg",
    alt: "saudi_elm icon",
    width: "262px",
    height: "44px"
  })))));
}
export default Footer;